import React from 'react';
import ReactJson from 'react-json-view';

const PerformanceDataView = ({ performanceData }) => {
    return (
        <div style={{ 
            height: "calc(100vh - 300px)", 
            overflow: "auto",
            border: "1px solid #dee2e6",
            borderRadius: "4px",
            padding: "12px"
        }}>
            <ReactJson
                src={performanceData}
                theme="monokai"
                collapsed={false}
                indentWidth={2}
                enableClipboard={true}
                displayDataTypes={false}
                style={{ backgroundColor: 'transparent' }}
            />
        </div>
    );
};

export default PerformanceDataView;

